/**
 *
 * Collapse Script
 *
 * @author Yusuke Manabe @ Space-Time Inc.
 * @author Takuto Yanagida @ Space-Time Inc.
 * @version 2020-11-03
 *
 */

(function() {

	const btns = document.querySelectorAll('.stile a.collapse-button');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (! btn.href || btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const next = p.nextElementSibling;
		return next.classList.contains('collapse');
	}

	function setEventListener(btn) {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setCollapse(btn, false);
			} else {
				btn.classList.add('active');
				setCollapse(btn, true);
			}
		});
	}


	function setCollapse(btn, visible) {
		const p         = btn.parentElement;
		const next      = p.nextElementSibling;
		const inners    = Array.from(next.children);

		if (visible) {
			next.classList.remove('collapse');
			next.classList.add('collapsing');
			let innerHeight = 0;
			inners.forEach(element => { innerHeight += element.offsetHeight; });
			next.style.height = innerHeight + 'px';
			setTimeout(function() {
				next.style.height = '';
				next.classList.remove('collapsing');
				next.classList.add('collapse', 'show');
			}, 350);
		} else {
			next.style.height = next.offsetHeight + 'px';
			next.offsetHeight;
			next.classList.add('collapsing');
			next.classList.remove('collapse', 'show');
			next.style.height = '';
			setTimeout(function() {
				next.classList.remove('collapsing');
				next.classList.add('collapse');
			}, 350);
		}
	}

}());
